import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import Header from "../HeaderComponent/Header";
import history from "../../auth/history";

import '../MoneyTransferComponent/TransactionList.css';
import FooterComponet from "../FooterComponent/FooterComponet";

import SubTransactionTxn from "../MoneyTransferComponent/SubTransactionTxn";
import moment from "moment";
import { CSVLink } from "react-csv";
import FinxPayLogo1 from "../../assests/images/finxpay.png";
import FinxPayLogo from "../../assests/images/finxpay.png";
import FinxPayLogo2 from "../../assests/images/finxpay.png";

import { v4 as uuidv4 } from 'uuid';
import Pagination from "react-js-pagination";
import { store } from "../../redux/store";
import { setTxnHistoryElementNo, setTxnHistoryResponse, setTxnReportingData, setTxnHistoryPaginationResponse, selectedSender, selectedBeneList, setBeneMoneyTransfer, setSendersListDetails, setRechargeType, setRechargeTxhHistory } from '../../redux/misc-data/misc-data.action';
import HeaderCommon from '../HeaderComponent/HeadeCommon';
import ContentLoader from 'react-content-loader';
import Menu from "../MenuComponent/Menu";
import { Link } from "react-router-dom";
import Subtransaction from "./Subtransaction";
import OrderDetails from "./OrderDetails";
import TransferDetails from "./TransferDetails";
import { setFilterEndDate, setFilterStartDate } from "../../redux/billpayDetails/billpay.action";
import tokenErrorHandler from "../tokenErrorHandler";
const httpClient = axios.create();


class BillPayAllTxn extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			password: '',
			otpRef: '',
			message: '',
			loading: false,
			txnData: '',
			showModal: false,
			surcharge: '',
			totalAmount: '',
			orderId: '',
			createdOn: '',
			paymentStatus: '',
			searchTxn: '',
			formDate: '',
			toDate: '',
			activePage: 1,
			statusList: [
				{ value: "Select", label: "Select" },
				{ value: "Success", label: "Success" },
				{ value: "Failed", label: "Failed" },
				{ value: "Pending", label: "Pending" },
				{ value: "Processing", label: "Processing" }
			],
			selectedStatus: '',
			applyFiler: false,
			errorMessage: '',
			enteredTxn: '',
			contentLoading: false,
			txnSubOrder: '',
			billpayTxnHistory: [],
			totalElements: 0,
			totalPages: 0,
			debitedFrom: '',
			payRef: '',
			payTxnId: '',
			billerId: '',
			consumerNo: '',
			kNo: '',
			consumerName: '',
			billDate: '',
			dueDate: '',
			billNumber: '',
			showLogo: true
		}
	}



	enterTxn = (event) => {
		event.preventDefault();
		this.setState({
			enteredTxn: event.target.value.toLowerCase()
		})
	}

	searchTxn = (event) => {

		event.preventDefault();
		if (this.state.enteredTxn.length > 0) {

			var txnSearchurl = '/api/v1/billpay/order/search/' + this.state.enteredTxn.toLowerCase() + '/' + this.props.agentInfo.id;


			const headers = {
				'Authorization': 'Bearer ' + this.props.token,
				'client-id': this.props.agentInfo.id,
				'role': this.props.clientRole
			}

			this.setState({ activePage: 1 });

			httpClient.get(txnSearchurl, { headers }
			).then((response) => {

				console.log('txn search response' + JSON.stringify(response.data));
				if (response.data.response.msg == 'SUCCESS') {
					console.log('txn search success response....' + response.data);
					this.setState({
						billpayTxnHistory: response.data.orders,
						totalElements: response.data.totalElements,
						totalPages: response.data.totalPages
					})
				} else {
					this.errorMessageCall(response.data.response.displayMsg);
					this.setState({
						billpayTxnHistory: [],
						totalElements: response.data.totalElements,
						totalPages: response.data.totalPages
					})
				}
			}).catch(error => {
				if (error.message.includes("401")) {
					tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
				}

			});
		}




	}


	handlePageChangeDefault(pageNumber) {
		this.setState({
			activePage: pageNumber
		})



		console.log(pageNumber);
		var startDate = this.props.formDate;
		var endDate = this.props.toDate;
		this.loadTxnHistory(pageNumber - 1, this.props.formDate !== '' ? moment(this.props.formDate).format('YYYY-MM-DD') :
			'',
			this.props.toDate !== '' ?
				moment(this.props.toDate).format('YYYY-MM-DD') :
				'', this.state.selectedStatus);

	}


	moDalPrint = (event, txn) => {
		event.preventDefault();
		this.setState({
			showLogo: true
		})
		var paymentStatus = '';
		if (txn.status == '' || txn.status == undefined || txn.status == null) {
			paymentStatus = 'Failed';
		}

		if (txn.status == 'SUCCESS') {
			paymentStatus = 'Success';
		}
		if (txn.status == 'PENDING'
			|| txn.status == 'ACCEPTED'
			|| txn.status == 'PROCESSING'
			|| txn.status == 'HUNG') {
			paymentStatus = 'Successfully Submitted';
		}
		if (txn.status == 'FAILED'
			|| txn.status == 'FAIL'
			|| txn.status == 'INTERNAL_FAILURE'
			|| txn.status == 'SUCCESS_TO_FAILED'
			|| txn.status == 'NOT_FOUND') {
			paymentStatus = 'Failed';
		}
		if (txn.status == 'AUTO_REVERSED'
			|| txn.status == 'MANUALLY_REVERSED') {
			paymentStatus = 'Reversed';
		}

		var payRefId = '';
		var payTxnId = '';
		if (txn.optional != null &&
			txn.optional != undefined &&
			txn.optional != '' &&
			txn.optional.PAYMENT_REF_ID != '' &&
			txn.optional.PAYMENT_REF_ID != undefined &&
			txn.optional.PAYMENT_REF_ID != null) {
			//alert(1);
			payRefId = txn.optional.PAYMENT_REF_ID;
		} else {
			payRefId = txn.paymentRefId != ''
				&& txn.paymentRefId != undefined
				&& txn.paymentRefId != null
				&& txn.paymentRefId;
		}
		if (txn.optional != null &&
			txn.optional != undefined &&
			txn.optional != '' &&
			txn.optional.PAYMENT_TXN_ID != '' &&
			txn.optional.PAYMENT_TXN_ID != undefined &&
			txn.optional.PAYMENT_TXN_ID != null) {
			//alert(2);
			payTxnId = txn.optional.PAYMENT_TXN_ID;
		} else {
			payTxnId = txn.paymentTxnId != ''
				&& txn.paymentTxnId != undefined
				&& txn.paymentTxnId != null
				&& txn.paymentTxnId;
		}


		this.setState({
			showModal: true,
			paymentStatus: paymentStatus,
			transferredAmount: (txn.transaction != null && txn.transaction != undefined &&
				txn.transaction != '')
				? parseFloat(txn.transaction.amount).toFixed(2) :
				'0.00',
			orderId: txn.id != null ? txn.id : 'Unlnown Id',
			createdOn: moment(txn.createdOn).format('DD-MM-YYYY hh:mm:ss'),
			surcharge: (txn.status.toLowerCase() != 'failed' && txn.txnDetails != null) ?
				txn.txnDetails.surcharge != null ?
					parseFloat(txn.txnDetails.surcharge).toFixed(2) : '0.00' : '0.00',
			totalAmount: parseFloat((txn.transaction.amount) -
				(txn.txnDetails != null ? txn.txnDetails.surcharge : 0)).toFixed(2),
			debitedFrom: this.props.agentInfo.mobile,
			payRef: (payRefId != '' && payRefId != undefined && payRefId != null) ?
				payRefId : 'NA',
			payTxnId: (payTxnId != '' && payTxnId != undefined && payTxnId != null) ?
				payTxnId : 'NA',
			billerId: txn.billerTxnId,
			consumerNo: txn.optional != null && txn.optional.customer_number != null &&
				txn.optional.customer_number != '' && txn.optional.customer_number,
			kNo: txn.optional != null && txn.optional.K_NUMBER != null &&
				txn.optional.K_NUMBER != '' && txn.optional.K_NUMBER,
			consumerName: (txn.optional != null && txn.optional.name != null &&
				txn.optional.name != '' && txn.optional.name != undefined) ?
				txn.optional.name : 'NA',
			billDate: (txn.optional != null && txn.optional.billDate != null &&
				txn.optional.billDate != '' && txn.optional.billDate != undefined) ?
				txn.optional.billDate : 'NA',
			dueDate: (txn.optional != null && txn.optional.dueDate != null &&
				txn.optional.dueDate != '' && txn.optional.dueDate != undefined) ?
				txn.optional.dueDate : 'NA',
			billNumber: (txn.optional != null && txn.optional.billNumber != null &&
				txn.optional.billNumber != '' && txn.optional.billNumber != undefined) ?
				txn.optional.billNumber : 'NA',

		})
	}


	componentDidMount = () => {
		store.dispatch(setTxnHistoryElementNo(''));
		store.dispatch(setFilterStartDate(''));
		store.dispatch(setFilterEndDate(''));

		var startDate = moment().format('YYYY-MM-DD');
		console.log('to date..' + startDate);
		var d = new Date();
		d.setDate(d.getDate() + 2);

		var endDate = d.toISOString().slice(0, 10);
		console.log('start date' + startDate);

		var status = '';
		this.loadTxnHistory(0, '', '', status);
	}


	loadTxnHistory(pageNo, startDate, endDate, status) {
		var url = '';
		this.setState({
			contentLoading: true,
			errorMessage: ''
		})

		url = '/api/v1/billpay/order/history';


		var header = {
			msgType: "ORDER_HISTORY",
			service: 'BILLPAY',
			src: "billpay",
			dst: "billpay",
			channel: "API",
			requesterId: this.props.clientRequesterId,
			requestId: uuidv4(),
			traceId: uuidv4(),
		}


		var request = '';

		var request = {
			header: header,
			device: this.props.deviceInfo,
			agentId: this.props.agentInfo.id,
			pageNo: pageNo,
			startDate: startDate,
			endDate: endDate

		}


		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}

		console.log('txn history req:' + JSON.stringify(request));

		httpClient.post(url, request, {
			timeout: 180 * 1000,
			timeoutErrorMessage: 'timeout',
			headers
		}
		).then((response) => {



			this.setState({
				contentLoading: false,

			})
			console.log(' response' + JSON.stringify(response.data));

			// var orderBycreatedTime = response.data.orders;
			// orderBycreatedTime.sort(({ time: a }, { time: b }) => a > b ? 1 : a < b ? -1 : 0);
			// response.data.orders=orderBycreatedTime;

			if (response.data.response.msg == 'SUCCESS') {


				this.setState({
					billpayTxnHistory: response.data.orders,
					totalElements: response.data.totalElements,
					totalPages: response.data.totalPages
				})
				this.txnHistory();

			} else {
				this.setState({
					contentLoading: false,
					errorMessage: 'Something went wrong!'
				})

			}
		}).catch(error => {

			this.setState({
				contentLoading: false,
				errorMessage: 'Something went wrong!'
			})
			if (error.message.includes("401")) {
				tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
			}
		})
	}

	applyTxnHistory() {
		var url = '';
		this.setState({
			contentLoading: true,
			errorMessage: ''
		})

		url = '/api/v1/billpay/order/history';
		var header = {
			msgType: "ORDER_HISTORY",
			service: 'BILLPAY',
			src: "billpay",
			dst: "billpay",
			channel: "API",
			requesterId: this.props.clientRequesterId,
			requestId: uuidv4(),
			traceId: uuidv4(),
		}

		var request = '';
		var request = {
			header: header,
			device: this.props.deviceInfo,
			agentId: this.props.agentInfo.id,
			pageNo: 0,
			startDate: moment(this.props.formDate).format('YYYY-MM-DD'),
			endDate: moment(this.props.toDate).format('YYYY-MM-DD')
		}


		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}

		console.log('txn history req:' + JSON.stringify(request));

		httpClient.post(url, request, {
			timeout: 180 * 1000,
			timeoutErrorMessage: 'timeout',
			headers
		}
		).then((response) => {
			this.setState({
				contentLoading: false,

			})
			console.log(' response' + JSON.stringify(response.data));

			// var orderBycreatedTime = response.data.orders;
			// orderBycreatedTime.sort(({ time: a }, { time: b }) => a > b ? 1 : a < b ? -1 : 0);
			// response.data.orders=orderBycreatedTime;

			if (response.data.response.msg == 'SUCCESS') {
				this.setState({
					billpayTxnHistory: response.data.orders,
					totalElements: response.data.totalElements,
					totalPages: response.data.totalPages,
					activePage: 1
				})
				this.txnHistory();
			} else {
				this.setState({
					contentLoading: false,
					errorMessage: 'Something went wrong!'
				})

			}
		}).catch(error => {

			this.setState({
				contentLoading: false,
				errorMessage: 'Something went wrong!'
			})
			if (error.message.includes("401")) {
				tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
			}
		})
	}





	txnHistory = () => {
		store.dispatch(setTxnReportingData(''));
		var OrderId = '';
		var OrderCreatedOn = '';
		var orderList = [];
		var orderList1 = [];
		var rowList = [];
		var paymentStatus = '';
		this.state.billpayTxnHistory.map(res => {

			if (res.status == '' || res.status == undefined || res.status == null) {
				paymentStatus = 'Failed';
			}

			if (res.status == 'SUCCESS') {
				paymentStatus = 'Success';
			}
			if (res.status == 'PENDING'
				|| res.status == 'ACCEPTED'
				|| res.status == 'PROCESSING'
				|| res.status == 'HUNG') {
				paymentStatus = 'Successfully Submitted';
			}
			if (res.status == 'FAILED'
				|| res.status == 'FAIL'
				|| res.status == 'INTERNAL_FAILURE'
				|| res.status == 'SUCCESS_TO_FAILED'
				|| res.status == 'NOT_FOUND') {
				paymentStatus = 'Failed';
			}
			if (res.status == 'AUTO_REVERSED'
				|| res.status == 'MANUALLY_REVERSED') {
				paymentStatus = 'Reversed';
			}

			OrderId = res.id == null ? '' : res.id;
			OrderCreatedOn = res.createdOn == null ? '' : moment(res.createdOn).format('DD-MM-YYYY hh:mm:ss')
			var orderObj = {
				orderId: OrderId,
				orderCreatedOn: OrderCreatedOn,
				paymentStatus: paymentStatus
			}
			if (!orderList.includes(orderObj)) {
				orderList.push(orderObj);
			}
		})
		// console.log('order List:'+JSON.stringify(orderList1));
		console.log('order List size:' + orderList.length);


		orderList.map(order => {

			console.log('order ..' + order.orderId);

			var row = {

				PaymentStatus: '',
				OrderId: '',
				OrderCreatedOn: '',

			}


			row.OrderId = order.orderId;
			row.OrderCreatedOn = order.orderCreatedOn;
			row.PaymentStatus = order.paymentStatus;
			if (!rowList.includes(row)) {
				rowList.push(row);
			}
		})
		console.log('rowList::' + JSON.stringify(rowList));
		store.dispatch(setTxnReportingData(rowList));
	}
	componentWillUnmount() {
	}





	statusSelect = (event) => {
		if (event.target.value == 'Select') {
			alert('Please select a  status');

		} else {
			this.setState({
				selectedStatus: event.target.value
			})
		}
	}


	formDateSelect = (event) => {
		console.log(event.target.value);
		store.dispatch(setFilterStartDate(event.target.value))
	}


	toDateSelect = (event) => {
		console.log(event.target.value);
		store.dispatch(setFilterEndDate(event.target.value))

	}


	resetExportDate = (event) => {
		setTimeout(() => {
			store.dispatch(setTxnReportingData(''));
		}, 200);
	}


	printdiv = (event) => {
		event.preventDefault();
		this.setState({
			showLogo: false
		})

		// printJS('print', 'html')
		setTimeout(() => {
			var divContents = document.getElementById("print").innerHTML;
			var a = window.open('', '', 'height=500, width=500');
			a.document.write('<html>');
			a.document.write('<body>');
			a.document.write(divContents);
			a.document.write('</body></html>');
			a.document.close();
			a.print();
		}, 100);

	}

	clearAll = (event) => {
		this.setState({
			selectedStatus: '',
			activePage: 1

		})

		store.dispatch(setFilterEndDate(''));
		store.dispatch(setFilterStartDate(''));

		var startDate = moment().format('YYYY-MM-DD');
		console.log('to date..' + startDate);
		var d = new Date();
		d.setDate(d.getDate() + 2);

		var endDate = d.toISOString().slice(0, 10);
		console.log('start date' + startDate);

		var status = '';
		this.loadTxnHistory(0, '', '', status);
	}


	submitFilter = (event) => {
		event.preventDefault();
		this.setState({
			applyFiler: 'true'
		});

		this.setState({
			contentLoading: true
		})

		if (this.props.formDate == '' && this.props.toDate == '') {
			alert('Please enter start date or End date');
		} else {
			if (this.props.formDate == '') {
				alert('Please enter start date');
			}

			if (this.props.toDate == '') {
				alert('Please enter end date');
			}
		}

		if (this.props.formDate != '' && this.props.toDate != '') {
			// this.loadTxnHistory(this.state.activePage, moment(this.props.formDate).format('YYYY-MM-DD'),
			// 	moment(this.props.toDate).format('YYYY-MM-DD'), this.state.selectedStatus);
			this.applyTxnHistory();
		}
	}




	errorMessageCall = (error) => {
		this.setState({
			errorMessage: error
		})
	}


	render() {
		var recentTxnLoop = ['test', 'test', 'test', 'test', 'test'];
		return (

			<div>
				<HeaderCommon />
				<Menu />
				<div class="main">


					<div class="right-side">
						<div class="container-fluid">


							<div class="row">
								<div class="col-12">
									<div class="card-b" id="rightdiv">
										<div id="recenttxn">
											<div class="head">
												<h3>Transaction History</h3>
												<Link to='/billpay'>
													<button class="back" type="button">Back</button>
												</Link>
												<Link to='/money-transfer'>
													<button id='moneytransfer' hidden={true}></button>
												</Link>

												{/* {this.props.exportData == '' &&
													<button class="exprt" type="button" onClick={this.txnHistory}>exprt</button>
												} */}

												{this.props.exportData != '' &&
													<CSVLink
														class="exprt"
														data={this.props.exportData}
														asyncOnClick={true}
														onClick={this.resetExportDate}
														filename={"Billpay-" + moment().format('DD-MM-YYYY') + ".csv"}

													>
														Download
													</CSVLink>
												}

												<div class="dropdown fltr">
													<button type="button" class="filter dropdown-toggle" id="fillist" data-bs-toggle="dropdown" data-bs-auto-close="false" aria-expanded="false">Filter</button>

													<div class="dropdown-menu dropdown-menu-end" aria-labelledby="fillist">
														<form>
															<div class="filters">
																<label for="status">Status:</label>


																<select class="form-select" id="status"
																	aria-label=""
																	onChange={this.statusSelect} required>

																	{this.state.statusList.map(status => (
																		<option value={status.value}
																		>{status.label}</option>
																	))}

																</select>

															</div>

															<div class="filters">
																<label for="select-state">From Date:</label>
																<input type="date" name="" id=""
																	onChange={this.formDateSelect}
																/>
															</div>

															<div class="filters">
																<label for="select-state">To Date:</label>
																<input type="date" name="" id=""
																	onChange={this.toDateSelect} />
															</div>

															<div class="fbtn">
																<button class="dbbtn" type="submit" id="btnClear"
																	onClick={this.submitFilter}>Apply</button>
																<button class="lbbtn" type="reset" id="btnClear" onClick={this.clearAll}>Clear</button>
															</div>
														</form>
													</div>



													<div class="headsearch">
														<div class="input-group">
															<input type="text" class="form-control" onChange={this.enterTxn} placeholder="Search transaction..." />
															<button class="btn search" type="button" id="txnsrch" onClick={this.searchTxn}></button>
															<button
																style={{ background: "#FF8D33", marginLeft: "3px" }}
																class="btn delete"
																// disabled={search.length <= 3}
																type="button"
																onClick={this.clearAll}
															>Clear</button>
														</div>
													</div>
												</div>

											</div>
											<div class="txn-list" id="recntxn">


												{this.state.errorMessage == '' &&
													this.state.billpayTxnHistory != ''
													&& this.state.billpayTxnHistory.length > 0 &&
													this.state.billpayTxnHistory.map((txnOrder, index) => (

														<div class="txn-item">

															<div class="txn-head" id={"txnhead" + index}>
																<div class="collapsed" data-bs-toggle="collapse" data-bs-target={"#txn" + index}
																	aria-expanded="false" aria-controls={"txn" + index}>
																	<div class={txnOrder.status == 'SUCCESS' ? "txncard grbg" :
																		(txnOrder.status == 'PENDING'
																			|| txnOrder.status == 'ACCEPTED'
																			|| txnOrder.status == 'PROCESSING'
																			|| txnOrder.status == 'HUNG'
																		) ? "txncard ylbg" :
																			(txnOrder.status == 'FAILED'
																				|| txnOrder.status == 'FAIL'
																				|| txnOrder.status == 'INTERNAL_FAILURE'
																				|| txnOrder.status == 'SUCCESS_TO_FAILED'
																				|| txnOrder.status == 'NOT_FOUND'
																			) ? "txncard rdbg" :
																				"txncard ylbg"}>

																		<div class="row">
																			<div class="col-12 col-md-5">
																				<div class="txntype">

																					{/* <img src={"images/" + txnOrder.transaction.operator.toLowerCase() + ".png"} alt="Airtel" data-toggle="tooltip" title="Airtel" /> */}
																					<h5>{(txnOrder.transaction != null && txnOrder.transaction.operator != null) ? txnOrder.transaction.operator : 'NA'}</h5>

																					{/* <p>{txnOrder.transaction != null ?
																						(txnOrder.transaction.mobile != null &&
																							txnOrder.transaction.mobile != undefined &&
																							txnOrder.transaction.mobile != '') ?
																							txnOrder.transaction.mobile :
																							(txnOrder.transaction.customerId != null &&
																								txnOrder.transaction.customerId != undefined &&
																								txnOrder.transaction.customerId != '') ?
																								txnOrder.transaction.customerId : 'NA' : 'NA'}</p> */}
																					<p>{txnOrder.optional != null &&
																						(txnOrder.optional.K_NUMBER != null &&
																							txnOrder.optional.K_NUMBER != undefined &&
																							txnOrder.optional.K_NUMBER != '') ?
																						txnOrder.optional.K_NUMBER :
																						'NA'}</p>
																				</div>
																			</div>
																			<div class="col-7 col-md-4">
																				<h6>{txnOrder.id != null ?
																					txnOrder.id.toUpperCase() : 'NA'}</h6>
																				<p> {txnOrder.createdOn != null ?
																					moment(txnOrder.createdOn).format('DD-MM-YYYY HH:mm:ss') : 'NA'}</p>
																			</div>
																			<div class="col-5 col-md-3">
																				<div class="txnamt">

																					<h4>₹ {txnOrder.transaction != null ?
																						txnOrder.transaction.amount != null ?
																							parseFloat(txnOrder.transaction.amount).toFixed(2) : 'NA' : 'NA'}</h4>
																					{txnOrder.status == 'SUCCESS' &&
																						<p class="success">Success</p>
																					}
																					{(txnOrder.status == 'PENDING'
																						|| txnOrder.status == 'ACCEPTED'
																						|| txnOrder.status == 'PROCESSING'
																						|| txnOrder.status == 'HUNG'
																					) &&
																						<p class="pending">Successfully Submitted</p>
																					}

																					{(txnOrder.status == 'FAILED'
																						|| txnOrder.status == 'FAIL'
																						|| txnOrder.status == 'INTERNAL_FAILURE'
																						|| txnOrder.status == 'SUCCESS_TO_FAILED'
																						|| txnOrder.status == 'NOT_FOUND') &&
																						<p class="failed">Failed</p>
																					}
																					{(txnOrder.status == 'AUTO_REVERSED'
																						|| txnOrder.status == 'MANUALLY_REVERSED'
																					) &&
																						<p class="pending">Reversed</p>
																					}

																					{(txnOrder.status == '' || txnOrder.status == undefined || txnOrder.status == null) &&
																						<p class="failed">{txnOrder.status.substring(0, 1).toUpperCase() +
																							txnOrder.status.substring(1, txnOrder.status.length).toLowerCase()}</p>
																					}


																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>

															<div id={"txn" + index} class="accordion-collapse collapse" aria-labelledby={"txnhead" + index}
																data-bs-parent="#recntxn">
																<div class="txn-details">
																	<div class="row">
																		<div class="txn-no">
																			<h6>Debited from:</h6>
																			<p>TA -  {this.props.agentInfo.id}</p>
																		</div>

																		<div class="blnc-amount">
																			<p>TA Balance</p>
																			<h6>₹ NA</h6>
																		</div>

																	</div>

																	<Subtransaction txnOrder={txnOrder} />
																</div>

																{/* <div class="ordertxn"> */}

																{/* </div> */}


																<div class="ordertxn">

																	<div class="row">
																		{
																			<OrderDetails amount={txnOrder.transaction != null ?
																				txnOrder.transaction.amount != null ?
																					parseFloat(txnOrder.transaction.amount).toFixed(2) : 'NA' : 'NA'}
																				surcharge={(txnOrder.status.toLowerCase() != 'failed' && txnOrder.txnDetails != null) ?
																					txnOrder.txnDetails.surcharge != null ?
																						parseFloat(txnOrder.txnDetails.surcharge).toFixed(2) : '0.00' : '0.00'}
																				totalAmount={parseFloat((txnOrder.transaction.amount) - (txnOrder.txnDetails != null ? txnOrder.txnDetails.surcharge : 0)).toFixed(2)}
																				res={0} />
																		}

																		{
																			<TransferDetails amount={(txnOrder.status.toLowerCase().includes('fail') == false && txnOrder.transaction != null) ?
																				txnOrder.transaction.amount != null ?
																					parseFloat(txnOrder.transaction.amount).toFixed(2) : 'NA' : '0.00'}
																				surcharge={(txnOrder.status.toLowerCase().includes('fail') == false && txnOrder.txnDetails != null) ?
																					txnOrder.txnDetails.surcharge != null ?
																						parseFloat(txnOrder.txnDetails.surcharge).toFixed(2) : '0.00' : '0.00'}
																				totalAmount={txnOrder.status.toLowerCase().includes('fail') == false ? parseFloat((txnOrder.transaction.amount) - (txnOrder.txnDetails != null ? txnOrder.txnDetails.surcharge : 0)).toFixed(2)
																					: parseFloat(0).toFixed(2)}
																				res={0} />
																		}


																	</div>
																</div>

																<div class="txn-btn">
																	{/* <button type="button" class="retry" onClick={e => this.moneyTransfer(e, txnOrder)}>Repeat</button> */}
																	{
																		<button type="button" class="print"
																			data-bs-toggle="modal"
																			data-bs-target="#print"
																			onClick={e => this.moDalPrint(e, txnOrder)}>Print</button>
																	}


																</div>
															</div>
														</div>

													))
												}

												{
													this.state.errorMessage == '' &&
													this.state.contentLoading == false &&
													this.state.billpayTxnHistory.length == 0 &&
													<div>
														No records found
													</div>
												}

												{this.state.errorMessage == '' &&
													this.state.contentLoading == true &&
													// this.props.txnPaginationResponse!='' &&
													recentTxnLoop.map((rctn, index) => (
														<div class="txn-item">
															<div class="txncard">
																<ContentLoader
																	width={350}

																	height={50}
																	speed={1}
																	backgroundColor="#f3f3f3"
																	foregroundColor="#ecebeb"
																	viewBox="0 0 350 50"
																><rect x="48" y="8" rx="3" ry="3" width="100" height="6" />
																	<rect x="48" y="26" rx="3" ry="3" width="40" height="6" />
																	<circle cx="20" cy="20" r="20" />
																</ContentLoader>
															</div>
														</div>
													)
													)
												}



												{this.state.errorMessage != '' &&
													<div class='valid-error'>
														{this.state.errorMessage}
													</div>}


											</div>


											{

												this.state.contentLoading == false &&
												this.state.billpayTxnHistory != null &&
												this.state.billpayTxnHistory.length > 0 &&
												<div class="pager">

													<p>
														{"Showing " + (((this.state.activePage - 1) * 20) + 1) + " to " +
															(this.state.totalElements < (((this.state.activePage - 1) * 20) + this.state.billpayTxnHistory.length) ?
																this.state.totalElements :
																(((this.state.activePage - 1) * 20) + this.state.billpayTxnHistory.length))
															+ " no records of total " +
															this.state.totalElements}  entries</p>

													<Pagination
														activePage={this.state.activePage}
														itemsCountPerPage={this.state.totalElements / this.state.totalPages}
														totalItemsCount={
															this.state.totalElements}
														pageRangeDisplayed={this.state.totalPages}
														onChange={this.handlePageChangeDefault.bind(this)}
														className="pagination"
														linkClass="page-link"
														itemClass="page-item"
													/>
												</div>
											}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<FooterComponet />

				{/* {this.state.showModal} */}

				<div class="modal fade" id="print" data-bs-backdrop="static"
					data-bs-keyboard="false" tabindex="-1">
					<div class="modal-dialog">
						<div class="modal-content">
							{/* <div class="modal-header modhead">
								<h5 class="modal-title">Billpay Receipt</h5>
								{this.state.showLogo == true &&
									<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
								}
							</div> */}
							<div class="modal-body">
								<div class="printtable">
									{this.state.showLogo == true &&
										<div class="printlogo">

											<img src={FinxPayLogo1} alt="logo" />
											&emsp;
											&emsp;
											&emsp;
											&emsp;
											&emsp;
											&emsp;
											&emsp;
											&emsp;
											&emsp;
											&emsp;
											&emsp;
											&emsp;
											&emsp;


										</div>
									}
									{this.state.showLogo == false &&
										<div class="printlogo">
											<img src={FinxPayLogo1} alt="logo" />
											&emsp;
											&emsp;
											&emsp;
											&emsp;
											&emsp;
											&emsp;
											&emsp;
											&emsp;
											&emsp;
											&emsp;
											&emsp;
											&emsp;
											&emsp;
											&emsp;
											&emsp;
											&emsp;
											&emsp;



										</div>
									}

									<table class="table table-striped table-bordered" border="1" border-collapse>
										<tbody>
											<tr>
												<td>Payment Status:</td>
												<td><strong>Billpay {this.state.paymentStatus}</strong></td>
											</tr>

											<tr>
												<td>Billpay Amount:</td>
												<td>₹ {this.state.transferredAmount}</td>
											</tr>
											{/* <tr>
												<td>Comission:</td>
												<td>₹ {this.state.surcharge}</td>
											</tr> */}



											{/* <tr>
												<td>Total Amount:</td>
												<td>₹ {parseFloat(this.state.totalAmount).toFixed(2)}</td>
											</tr> */}

											{/* <tr>
												<td>Order Id:</td>
												<td>{this.state.orderId}</td>
											</tr> */}

											<tr>
												<td>Date:</td>
												<td>{this.state.createdOn}</td>
											</tr>
											<tr>
												<td>Debited From:</td>
												<td>{this.props.agentInfo.id}</td>
											</tr>

											{(this.state.payRef != '' &&
												this.state.payRef != undefined &&
												this.state.payRef != null &&
												this.state.payRef != null) &&
												<tr>
													<td>Reference No:</td>
													<td>{this.state.payRef}</td>
												</tr>
											}
											{(this.state.payTxnId != '' &&
												this.state.payTxnId != undefined &&
												this.state.payTxnId != null) &&
												<tr>
													<td>Transaction Id:</td>
													<td>{this.state.payTxnId}</td>
												</tr>
											}
											{(this.state.billerId != '' &&
												this.state.billerId != undefined &&
												this.state.billerId != null) &&
												<tr>
													<td>Biller Txn Id:</td>
													<td>{this.state.billerId}</td>
												</tr>
											}
											<tr>
												<td>Consumer_No/K_NUMBER/Consumer_Name/BILL_NUMBER:</td>
												<td>{this.state.consumerNo}/{this.state.kNo}/{this.state.consumerName}/{this.state.billNumber}</td>
											</tr>
											{/* {(this.state.consumerNo != '' &&
												this.state.consumerNo != undefined &&
												this.state.consumerNo != null) &&
												<tr>
													<td>Consumer No:</td>
													<td>{this.state.consumerNo}</td>
												</tr>
											}
											{(this.state.kNo != '' &&
												this.state.kNo != undefined &&
												this.state.kNo != null) &&
												<tr>
													<td>K_NUMBER:</td>
													<td>{this.state.kNo}</td>
												</tr>
											}
											{(this.state.consumerName != '' &&
												this.state.consumerName != undefined &&
												this.state.consumerName != null) &&
												<tr>
													<td>Consumer Name:</td>
													<td>{this.state.consumerName}</td>
												</tr>
											} */}
											{/* {(this.state.billDate != '' &&
												this.state.billDate != undefined &&
												this.state.billDate != null) &&
												<tr>
													<td>Bill Date:</td>
													<td>{this.state.billDate}</td>
												</tr>
											}
											{(this.state.dueDate != '' &&
												this.state.dueDate != undefined &&
												this.state.dueDate != null) &&
												<tr>
													<td>Due Date:</td>
													<td>{this.state.dueDate}</td>
												</tr>
											} */}
											{/* {(this.state.billNumber != '' &&
												this.state.billNumber != undefined &&
												this.state.billNumber != null) &&
												<tr>
													<td>Bill Number:</td>
													<td>{this.state.billNumber}</td>
												</tr>
											} */}

										</tbody>
									</table>

									{this.state.txnSubOrder != '' &&

										<table class="table table-bordered">
											<tbody>
												<tr>
													<td colspan="3">Sub Transactions Details:</td>
												</tr>
												<tr class="table-secondary">
													<td>Transactions ID</td>
													<td>Amount</td>
													<td>Status</td>
													<td>Payment Ref.</td>
												</tr>

												{this.state.txnSubOrder.map(txRsp => (

													<tr>
														<td>{txRsp.id}</td>
														<td>₹ {parseFloat(txRsp.txnDetails.amount).toFixed(2)}</td>
														<td>{txRsp.status == 'INIT' ? 'Pending' : txRsp.status.substring(0, 1).toUpperCase() +
															txRsp.status.substring(1, txRsp.status.length).toLowerCase()}</td>
														<td>
															{txRsp.paymentRefId}
														</td>
													</tr>
												))
												}
											</tbody>
										</table>
									}


								</div>
							</div>

							{this.state.showLogo == true &&
								<div class="modal-footer mdftr">
									<button type="button" class="btn dbbtn" data-bs-dismiss="modal" aria-label="Close">Clsoe</button>
									<button type="button" class="btn dbbtn" data-bs-dismiss="modal" onClick={this.printdiv}>Print</button>
								</div>
							}
						</div>
					</div>
				</div>



			</div >
		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone, agentInfo, token, clientRole, clientRequesterId, txnHistoryResponse, exportData, totalElementsNo,
			txnPaginationResponse, rechargeType, deviceInfo, rechargeTxnHistory, callBackUrl },
		billpayReduce: { formDate, toDate } }
) => ({
	errorMessage, loginErrorMessage, phone, agentInfo, token, clientRole, clientRequesterId, txnHistoryResponse, exportData,
	totalElementsNo,
	txnPaginationResponse, rechargeType, deviceInfo, rechargeTxnHistory, callBackUrl,
	formDate, toDate
});

export default connect(mapStateToProps, null)(BillPayAllTxn);
